var React = require('react');

function InfoIconCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.5 15C11.366 15 14.5 11.866 14.5 8C14.5 4.13401 11.366 1 7.5 1C3.63401 1 0.5 4.13401 0.5 8C0.5 11.866 3.63401 15 7.5 15Z","stroke":"#22202F","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.49 5C7.49 5 7.49224 5 7.495 5C7.49776 5 7.5 5 7.5 5C7.5 5 7.49776 5 7.495 5C7.49224 5 7.49 5 7.49 5Z","stroke":"#22202F","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.5 7V11","stroke":"#22202F","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

InfoIconCircle.defaultProps = {"width":"15","height":"16","viewBox":"0 0 15 16","fill":"none"};

module.exports = InfoIconCircle;

InfoIconCircle.default = InfoIconCircle;
